import declare from "dojo/_base/declare";
import HomePageUtil from "./util";
import NewSupplierPortalPaneForm from "./NewSupplierPortalPaneForm";

const NewSupplierPortalProofingPaneForm = declare(NewSupplierPortalPaneForm, {
	allowedPaneIds: [
		"HomeMyProofs",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [HomePageUtil.DOMAIN];
	},
});

export = NewSupplierPortalProofingPaneForm;